import moment from 'moment';

export function formatCartItemDate(addDate, changeDate) {
  if(!addDate || !changeDate){
    return 0;
  }
  
  return moment().diff(changeDate || addDate || moment().format('x'), 'days');
}



/** WEBPACK FOOTER **
 ** ./src/components/Cart/helpers/index.js
 **/